import { FigureLabel } from '@/components/ui'
import type { MerchantStat } from '@/modules/projects/stores/types'
import { amountTone, numberToCurrency } from '@/utils'
import { StatTileGrid } from '../shared'
import { merchantNames } from './utils'

interface MetadataPanelProps {
  merchant: MerchantStat
  matchedCount: number
}

const TILE_CLASS = 'px-4 py-2.5'

export function MetadataPanel({ merchant, matchedCount }: MetadataPanelProps) {
  const variations = merchantNames(merchant)
  const avgAmount = merchant.count > 0 ? merchant.amount / merchant.count : 0

  const tiles = [
    {
      label: 'Net amount',
      value: numberToCurrency(merchant.amount),
      sub: `Across ${merchant.count.toLocaleString()} transactions`,
      valueClassName: amountTone(merchant.amount),
      className: TILE_CLASS,
    },
    {
      label: 'Transactions',
      value: merchant.count.toLocaleString(),
      sub:
        matchedCount === merchant.count
          ? 'All matched in the current dataset'
          : `${matchedCount.toLocaleString()} matched in the current dataset`,
      valueClassName: 'text-blue-7',
      className: TILE_CLASS,
    },
    {
      label: 'Average / txn',
      value: numberToCurrency(avgAmount),
      sub: 'Mean transaction amount',
      valueClassName: amountTone(avgAmount),
      className: TILE_CLASS,
    },
  ]

  return (
    <div className="overflow-hidden rounded-lg border">
      <StatTileGrid tiles={tiles} columns={3} />

      {variations.length > 1 && (
        <div className="border-t px-4 py-2">
          <FigureLabel className="mb-1">Original names</FigureLabel>
          <div className="flex flex-wrap gap-1.5">
            {variations.map((name) => (
              <span
                key={name}
                className="inline-flex items-center rounded-md border bg-white px-2 py-0.5 text-xs text-foreground"
              >
                {name}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
